export default class LoudnessMeter {
  constructor({ stream, onChange, pollingInterval = 100, precision = 0.01 }) {
    this.audioContext = new AudioContext();
    this.sourceNode = this.audioContext.createMediaStreamSource(stream);
    this.analyserNode = this.audioContext.createAnalyser();
    this.analyserNode.fftSize = 2048;
    this.sourceNode.connect(this.analyserNode);
    this.frequencyData = new Uint8Array(this.analyserNode.frequencyBinCount);
    this.getLoudnessLevel = this.getLoudnessLevel.bind(this);

    this.onChange = onChange;
    this.pollingInterval = pollingInterval;
    this.precision = precision;
    this.previousLevel = null;
    this.maxLevel = 0;
    this.timerId = null;
  }

  start() {
    this.timerId = setInterval(() => {
      const loudnessLevel = this.getLoudnessLevel();
      const roundedLevel = Math.round(loudnessLevel / this.precision) * this.precision;

      if (roundedLevel !== this.previousLevel) {
        this.onChange(roundedLevel);
        this.previousLevel = roundedLevel;
      }
    }, this.pollingInterval);
  }

  stop() {
    if(this.timerId){
      clearInterval(this.timerId);
      this.previousLevel = null;
      this.maxLevel = 0;
      delete this.timerId;      
    }
  }

  getLoudnessLevel() {
    this.analyserNode.getByteFrequencyData(this.frequencyData);
    const sum = this.frequencyData.reduce((accumulator, currentValue) => accumulator + currentValue);
    this.maxLevel = Math.max(this.maxLevel, Math.max(...this.frequencyData));
    const average = sum / this.frequencyData.length;
    const normalized = average / this.maxLevel;
    return normalized;
  }

  drop() {
    this.stop();
    this.sourceNode.disconnect();
    this.analyserNode.disconnect();
    this.audioContext.close();
  }
}